import { InternalMembersActions } from '@store/reducers/dashboard/actions'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import { call, delay, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'

const REQUEST_TIMEOUT = 1000

export function* fetchList({
  payload: { workspaceId },
}: ReturnType<typeof InternalMembersActions.fetchList>) {
  yield delay(REQUEST_TIMEOUT)
  const members: TeammateDto[] = yield call(
    NestClient.membership.list,
    workspaceId
  )
  yield put(InternalMembersActions.set({ workspaceId, members }))
}
